const v1 = 'v1/';
/**
 * @description
 * Contains api urls for all apis
 */
export const awsPreSignedUrl = {
  v1: {
    url: v1 + 'awspresignedurl',
  },
};

/**
 * @description
 * Contains api urls for all apis
 */
export const imagesApiUrls = {
  v1: {
    getImages: v1 + 'gallery',
    addImage: v1 + 'gallery'    
  },
};
